module.exports = __webpack_public_path__ + "img/jiangxi.b07f70b0.jpg";